import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mission',
  templateUrl: 'mission.component.html',
  styleUrls: ['mission.component.css']
})
export class MissionComponent implements OnInit {

  public sectionTitle:string = "La Nostra Missione";
  public sectionDescription: string = "Creare una comunità di persone che condividono la passione per la vela, il mare e la navigazione. Una comunità che vede nella share economy non solo un'opportunità di carattere economico, ma anche una nuova opportunità per condividere esperienze, accrescere le proprie conoscenze e navigare in mari sempre più aperti.";

  public subSection1Title = "Viaggi in Tutto Il Mondo";
  public subSection1Description = "Una sempre più larga rete di amicizie e relazioni, apre a nuove opportunità di solcare nuovi mari. Letterarmente. Non hai più bisongo di spostare la tua imbarcazione in nuove destinazioni, ma scegliere prima la destinazione e poi trovare nel posto un'imbarcazione a tua disposizione.";

  public subSection2Title = "Risparmi & Guadagni";
  public subSection2Description = "Nello spirito della share economy, risparmi sui costi di gestione della tua imbarcazione. Risparmi sui tempi perché non devi spostare la tua imbarcazione. Guadagni se metti a dispozione di altri la tua imbarcazione nei momenti in cui non la utilizzi.";

  public subSection3Title = "Fai Sport Divertendoti";
  public subSection3Description = "Nella comunità troverai sempre qualcuno con cui condividere il tuo sport preferito con altri appassionati. Condividere lo stupore e la libertà che ti si apre davanti al mare aperto.";

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/landingpage/sections/mission/mission.component.ts